import { render, staticRenderFns } from "./franchiseeOrderNodal.vue?vue&type=template&id=cf8939fa"
import script from "./franchiseeOrderNodal.vue?vue&type=script&lang=js"
export * from "./franchiseeOrderNodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports